import { ButtonGroup } from 'react-bootstrap';

import InputWithIconButton from 'components/InputWithIconButton';
import Button from 'components/Button';
import InlineTitle from 'components/InlineTitle';
import TooltipDialog from 'components/TooltipDialog';
import DropdownWithAdvancedSearch from 'components/DropdownWithAdvancedSearch';

import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import orgService from "services/Auth.Organization.service";
import { fromUrl } from "utils/downloadFile.util";
import { messageKeyPrefix } from "utils/message.util";
import { userPriv, userInvalid } from "utils/privilege.util";
import { cloneDeep, isNil, size } from 'lodash';

import { defaultMessages } from "../const";
import { userType, userPrivilege } from 'const/nuclias/user';

const defaultSearchInputKey = {
  searchKey: '',
  org: {
    key: '',
    label: '05cb2cca01'
  },
  site: {
    key: '',
    label: '668445f09d'
  }
};

const OrgManagementTableToolbarBox = ({
  info,
  handleSearch,
  modalStatus,
  handleModals,
  setMultiMessages
}) => {

  const { t } = useTranslation();
  const mb1 = info.isOrgUser ? 'mb-1' : '';
  const privilege = {
    createORG: (!userInvalid([userType.sp, userType.si]) || userPriv(userPrivilege.manager))
  }

  const [searchInputKey, setSearchInputKey] = useState(defaultSearchInputKey);

  const setSearch = (type, value) => {
    const copy = cloneDeep(searchInputKey);
    copy[type].key = value;
    setSearchInputKey(copy);
  };

  const changeSearchOption = (type, value) => {
    const copySearch = cloneDeep(searchInputKey);
    if (type) {
      copySearch[type].key = value;
    }
    const conditions = [];
    for (const [fieldIndex, field] of Object.entries(copySearch)) {
      if (!isNil(field?.key) && size(field?.key) > 0) {
        conditions.push(`(${t(field.label)}: ${t(field.key)})`);
      }
    }
    const conditionsStr = conditions.join(' AND ');
    copySearch.searchKey = conditionsStr;
    setSearchInputKey(copySearch);
    handleSearch(copySearch);
  };

  const downloadGenerateList = useCallback(async () => {
    await orgService.downloadGeneratedOrgReport(info.orgDs.id);
    if (orgService.hasError()) {
      const copy = cloneDeep(defaultMessages);
      copy.error = t(`${messageKeyPrefix.e.s}${orgService.error.originCode}`);
      setMultiMessages(copy);
    } else {
      fromUrl(orgService.data.data.downloadUrl);
    }
  }, []);

  return (
    <div className={`d-flex justify-content-between ${mb1}`}>
      <ButtonGroup>
        <Button
          label={t(modalStatus.org.createLabel)}
          disabled={privilege?.createORG}
          onClick={() => handleModals({ modal: 'org', status: true, type: 'create' })}
        ></Button>
      </ButtonGroup>
      <InlineTitle isNonUnderline>
        {!info.isOrgUser &&
          <>
            <Button
              label={t('de3e350386')}
              onClick={() => handleModals({ modal: 'generate', status: true, type: null })}
            />
            <Button
              label={t('801ab24683')}
              onClick={() => downloadGenerateList()}
            />
            <TooltipDialog placement='left' title={t('9d53acb410')} />
            <DropdownWithAdvancedSearch
              value={searchInputKey?.searchKey}
              alignEnd={true}
              readOnly
              dataBsToggleOnInput={true}
              dataBsToggleOnButton={true}
              dropdownMenuStyle={{ minWidth: 371 }}
            >
              <li className="mt-2">
                <div className="form-title">{t('05cb2cca01')} :</div>
                <InputWithIconButton
                  value={searchInputKey?.org?.key}
                  type="search"
                  placeholder={t('13348442cc')}
                  buttonClassName="icon-search-enter"
                  onChange={e => {
                    setSearch('org', e.target.value);
                  }}
                  onClick={e => {
                    if (size(searchInputKey?.org?.key) > 0) {
                      changeSearchOption('org', '');
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") { changeSearchOption(); }
                  }}
                  buttonOnClick={e => { changeSearchOption(); }}
                />
              </li>
              {info.userType !== userType.sp &&
                <li className="mt-2">
                  <div className="form-title">{t('668445f09d')} :</div>
                  <InputWithIconButton
                    value={searchInputKey?.site?.key}
                    type="search"
                    placeholder={t('13348442cc')}
                    buttonClassName="icon-search-enter"
                    onChange={e => {
                      setSearch('site', e.target.value);
                    }}
                    onClick={e => {
                      if (size(searchInputKey?.site?.key) > 0) {
                        changeSearchOption('site', '');
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") { changeSearchOption(); }
                    }}
                    buttonOnClick={e => { changeSearchOption(); }}
                  />
                </li>
              }
            </DropdownWithAdvancedSearch>
          </>
        }
      </InlineTitle>
    </div>
  );
};

export default OrgManagementTableToolbarBox;
